import { Link } from 'react-router-dom'
import { Cloud, Zap, Download, CheckCircle } from 'lucide-react'

const features = [
  {
    icon: Cloud,
    title: '50+ AWS Services',
    description: 'Lambda, EC2, S3, VPC, RDS, DynamoDB, CloudFront など50種類以上のAWSサービスに対応',
  },
  {
    icon: Zap,
    title: 'Instant Generation',
    description: 'サービスを選択してパラメータを入力するだけで、即座にTerraformコードを生成',
  },
  {
    icon: Download,
    title: 'Easy Download',
    description: '生成したコードはプレビューで確認後、ZIPファイルとしてダウンロード可能',
  },
  {
    icon: CheckCircle,
    title: 'Best Practices',
    description: 'AWSとTerraformのベストプラクティスに基づいたコードを自動生成',
  },
]

export default function HomePage() {
  return (
    <div className="py-12">
      {/* Hero Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          AWS Terraform Code Generator
        </h1>
        <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
          AWSサービスを選択するだけで、本番環境で使えるTerraformコードを自動生成。
          インフラのコード化を簡単に始められます。
        </p>
        <Link
          to="/generator"
          className="inline-flex items-center gap-2 btn btn-primary text-lg px-8 py-3"
        >
          <Zap className="w-5 h-5" />
          コード生成を始める
        </Link>
      </section>

      {/* Features Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
        <h2 className="text-2xl font-bold text-gray-900 text-center mb-12">Features</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature) => (
            <div key={feature.title} className="card text-center">
              <feature.icon className="w-12 h-12 text-orange-500 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* How It Works Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
        <h2 className="text-2xl font-bold text-gray-900 text-center mb-12">How It Works</h2>
        <div className="flex flex-col md:flex-row justify-center items-center gap-8">
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 font-bold text-xl mb-4">
              1
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">サービス選択</h3>
            <p className="text-sm text-gray-600 text-center max-w-xs">
              使用するAWSサービスをチェックボックスで選択
            </p>
          </div>
          <div className="hidden md:block text-gray-300 text-4xl">→</div>
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 font-bold text-xl mb-4">
              2
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">パラメータ入力</h3>
            <p className="text-sm text-gray-600 text-center max-w-xs">
              各サービスの設定値をフォームに入力
            </p>
          </div>
          <div className="hidden md:block text-gray-300 text-4xl">→</div>
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 font-bold text-xl mb-4">
              3
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">コード生成</h3>
            <p className="text-sm text-gray-600 text-center max-w-xs">
              Terraformコードを自動生成してダウンロード
            </p>
          </div>
        </div>
      </section>
    </div>
  )
}
